import { styled } from '@mui/material/styles'
import Typography, { TypographyProps } from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import Box from '@mui/material/Box'
import { DialogProps } from '@mui/material/Dialog'

const Header = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: theme.spacing(2, 3, 0, 3),
}))

export interface ModalHeaderProps {
  title: string
  titleVariant?: TypographyProps['variant']
  onClose?: DialogProps['onClose']
  showCloseIcon?: boolean
}

const ModalHeader = ({
  title,
  titleVariant = 'h6',
  onClose,
  showCloseIcon = true,
}: ModalHeaderProps) => (
  <Header>
    <Typography variant={titleVariant}>{title}</Typography>
    {showCloseIcon && (
      <IconButton
        data-testid="modal-close-button"
        onClick={event => {
          onClose?.(event, 'backdropClick') // small hack to close the modal
        }}
      >
        <CloseIcon sx={{ fontSize: theme => theme.typography.h6.fontSize }} />
      </IconButton>
    )}
  </Header>
)

export default ModalHeader
